import type { JSX } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { PlainTooltip } from "@similarweb/ui-components";

import type { Axis } from "app/components/RankingAxis/types";

import TooltipContent from "./TooltipContent";

type TooltipSchema = {
    children: JSX.Element;
    data: Axis;
};

const Tooltip = ({ children, data }: TooltipSchema) => {
    const {
        params: { granularity },
    } = useCurrentStateAndParams();

    return (
        <PlainTooltip
            variation="white"
            tooltipContent={
                <TooltipContent
                    data={data}
                    granularity={granularity}
                />
            }
        >
            {children}
        </PlainTooltip>
    );
};

export default Tooltip;
